import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) =>{
 return(
  data.map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, loadOptions }) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    loadOptions
  }))
 )
}

export const fields: any = {
  centralizedModules: mapFields(
    drilldownData["centralizedModules"]
  ),
};
